import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../../common/types';
import { SMLButton } from '../../../components/primitives/SMLButton';
import { themeMessages } from './themeMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the Theme panel; each part uses its own slice of it */
import styles from './ThemePanel.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ThemeDraftBarProps {
  isSaving: boolean;
  hasError: boolean;
  onCancel: () => void;
  onSave: () => void;
}

/**
 * The Save and Cancel bar of the open Theme panel on the song page. It shows while the draft is
 * different from the saved look. Save is off while the PATCH runs; a failed save shows one line and
 * keeps the draft.
 */
const ThemeDraftBarComponent: React.FC<ThemeDraftBarProps> = ({ isSaving, hasError, onCancel, onSave }) => {
  const intl = useIntl();
  return (
    <div className={styles.draftBar} data-testid="theme-draft-bar">
      <span className={styles.draftNote}>
        {hasError ? (
          <span className={styles.draftError} role="alert">
            {intl.formatMessage(themeMessages.saveFailed)}
          </span>
        ) : (
          intl.formatMessage(themeMessages.draftNote)
        )}
      </span>
      <span className={styles.draftActions}>
        <SMLButton disabled={isSaving} onClick={onCancel}>
          {intl.formatMessage(themeMessages.draftCancel)}
        </SMLButton>
        <SMLButton variant="primary" disabled={isSaving} onClick={onSave}>
          {intl.formatMessage(isSaving ? themeMessages.draftSaving : themeMessages.draftSave)}
        </SMLButton>
      </span>
    </div>
  );
};

export const ThemeDraftBar = TypedMemo(ThemeDraftBarComponent);
